module.exports = __webpack_public_path__ + "img/office-4.a8bc8c36.png";